(function () {
  if (window.v2Finder) return;

  var RANK_LABEL = ['あなたにおすすめ', '次点の候補', '3番目の候補'];
  var RESULT_HOLD = 700;

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  var LAST_KEY = 'v2finder:last';

  function store(key, value) {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function load(key) {
    try { return JSON.parse(window.sessionStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }

  function icon(name) {
    return name ? '<span class="v2-finder__opt-icon"><svg aria-hidden="true"><use href="#fi-' + name + '"></use></svg></span>' : '';
  }

  function init(root, opts) {
    if (!root || root.__finder) return;
    root.__finder = true;
    opts = opts || {};
    var dataEl = root.querySelector('[data-finder-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var qWrap = root.querySelector('[data-finder-questions]');
    var pool = root.querySelector('[data-finder-pool]');
    var slot = root.querySelector('[data-finder-pool-slot]');
    var result = root.querySelector('[data-finder-result]');
    var loading = root.querySelector('[data-finder-loading]');
    var picks = root.querySelector('[data-finder-picks]');
    var caption = root.querySelector('[data-finder-caption]');
    var steps = root.querySelector('[data-finder-steps]');
    var stepEl = root.querySelector('[data-finder-step]');
    var stepOffset = opts.stepOffset || 0;
    if (opts.label && caption) caption.textContent = opts.label;
    if (!qWrap || !pool) return;
    if (slot) slot.appendChild(pool);

    var cards = {};
    Array.prototype.forEach.call(pool.querySelectorAll('[data-handle]'), function (c) {
      cards[c.getAttribute('data-handle')] = c;
    });
    var products = data.products.filter(function (p) { return cards[p.handle]; });
    var questions = data.questions;
    var chipQ = data.chips ? questions.filter(function (q) { return q.id === data.chips; })[0] : null;
    var weights = data.weights || {};
    var answers = {};
    var current = 0;
    var shown = [];
    var holdTimer = null;

    function optionLabel(qid, val) {
      var q = questions.filter(function (x) { return x.id === qid; })[0];
      if (!q) return '';
      var o = q.options.filter(function (x) { return x.id === val; })[0];
      return o ? o.label : '';
    }

    function pickLabels() {
      return questions.filter(function (q) { return answers[q.id]; })
        .map(function (q) { return optionLabel(q.id, answers[q.id]); });
    }

    function renderPicks() {
      if (!picks) return;
      picks.innerHTML = '';
      pickLabels().forEach(function (label) {
        picks.appendChild(el('span', '', label));
      });
    }

    function returnUrl() {
      return window.location.pathname + '?finder_restore=' + encodeURIComponent(data.category) + '#finder';
    }

    function goToProduct(card) {
      var url = card.getAttribute('data-url');
      if (!url) return;
      var rank = shown.findIndex(function (p) { return p.handle === card.getAttribute('data-handle'); }) + 1;
      store(LAST_KEY, {
        category: data.category,
        handle: card.getAttribute('data-handle'),
        rank: rank || 1,
        picks: pickLabels(),
        returnUrl: returnUrl()
      });
      window.location.href = url + (url.indexOf('?') === -1 ? '?' : '&') + 'finder=' + encodeURIComponent(data.category) + '&rank=' + (rank || 1);
    }

    function setOff(node, off) {
      if (!node) return;
      node.classList.toggle('is-off', off);
      node.setAttribute('aria-hidden', off ? 'true' : 'false');
    }

    function renderSteps() {
      var total = questions.length + stepOffset;
      var pos = current + stepOffset;
      if (steps) {
        if (!steps.children.length) {
          for (var i = 0; i < total; i++) steps.appendChild(el('i'));
        }
        Array.prototype.forEach.call(steps.children, function (d, i) {
          d.classList.toggle('is-done', i < pos);
          d.classList.toggle('is-current', i === pos);
        });
      }
      var done = current >= questions.length && !(loading && !loading.classList.contains('is-off'));
      if (stepEl) {
        stepEl.textContent = current < questions.length ? (pos + 1) + '/' + total : '';
        stepEl.hidden = current >= questions.length;
      }
      if (caption) caption.hidden = done;
      if (picks) picks.hidden = !done;
      root.dispatchEvent(new CustomEvent('v2finder:change', { detail: { step: current, total: questions.length, done: done, answered: Object.keys(answers).length, chip: chipQ ? (answers[chipQ.id] || null) : null } }));
    }

    function score(p) {
      var s = 0;
      questions.forEach(function (q) {
        var a = answers[q.id];
        if (!a) return;
        var tags = (p.tags && p.tags[q.id]) || [];
        var idx = tags.indexOf(a);
        if (idx === -1) return;
        s += (weights[q.id] || 1) * (idx === 0 ? 1 : 0.85);
      });
      return s;
    }

    function rank() {
      return products.map(function (p, i) { return { p: p, s: score(p), i: i }; })
        .sort(function (a, b) { return b.s - a.s || a.i - b.i; })
        .map(function (r) { return r.p; });
    }

    function hideAllCards() {
      Object.keys(cards).forEach(function (h) {
        cards[h].hidden = true;
        cards[h].style.order = '';
        cards[h].classList.remove('is-top');
      });
      shown = [];
    }

    function showRanked(list) {
      shown = list;
      list.forEach(function (p, i) {
        var c = cards[p.handle];
        var r = c.querySelector('[data-finder-card-reason]');
        var e = c.querySelector('[data-finder-card-rank]');
        var m = c.querySelector('[data-finder-card-more]');
        if (r) r.textContent = p.reason || '';
        if (m) {
          m.hidden = !p.more;
          if (p.more) { m.href = p.more.url; m.textContent = p.more.label; }
        }
        if (e) e.textContent = RANK_LABEL[i] || RANK_LABEL[RANK_LABEL.length - 1];
        c.style.order = String(i);
        c.classList.toggle('is-top', i === 0);
        c.style.setProperty('--i', String(i));
        c.hidden = false;
      });
    }

    function buildWizard() {
      qWrap.innerHTML = '';
      questions.forEach(function (q, qi) {
        var panel = el('div', 'v2-finder__q');
        panel.setAttribute('data-q', q.id);
        setOff(panel, qi !== 0);
        panel.appendChild(el('p', 'v2-finder__q-title', q.title));
        var opts = el('div', 'v2-finder__opts');
        opts.setAttribute('data-count', q.options.length);
        q.options.forEach(function (o) {
          var b = el('button', 'v2-finder__opt v2-finder__opt--tile',
            icon(o.icon) +
            '<span class="v2-finder__opt-text"><span class="v2-finder__opt-label">' + o.label + '</span></span>' +
            '<span class="v2-finder__opt-check"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>');
          b.type = 'button';
          b.setAttribute('data-q', q.id);
          b.setAttribute('data-val', o.id);
          opts.appendChild(b);
        });
        panel.appendChild(opts);
        var back = el('button', 'v2-finder__back', '前の質問に戻る');
        back.type = 'button';
        back.setAttribute('data-finder-back', '');
        if (qi === 0) back.setAttribute('aria-hidden', 'true');
        panel.appendChild(back);
        qWrap.appendChild(panel);
      });
    }

    function showPanel(idx, animateOut) {
      root.classList.remove('is-done');
      var prev = current;
      current = idx;
      window.clearTimeout(holdTimer);
      setOff(loading, true);
      Array.prototype.forEach.call(qWrap.querySelectorAll('.v2-finder__q'), function (p, i) {
        if (i === idx) {
          setOff(p, false);
          p.classList.remove('is-in', 'is-out');
          void p.offsetWidth;
          p.classList.add('is-in');
        } else if (animateOut && i === prev) {
          p.classList.add('is-out');
          window.setTimeout(function () {
            p.classList.remove('is-out');
            setOff(p, true);
          }, 220);
        } else {
          p.classList.remove('is-out');
          setOff(p, true);
        }
      });
      if (result && !result.classList.contains('is-out')) setOff(result, true);
      renderSteps();
    }

    function revealResult() {
      var ranked = rank();
      if (!ranked[0]) return;
      root.classList.add('is-done');
      store('v2finder:answers:' + data.category, answers);
      hideAllCards();
      showRanked(ranked.slice(0, 3));
      renderPicks();
      setOff(loading, true);
      if (result) {
        setOff(result, false);
        result.classList.remove('is-in');
        void result.offsetWidth;
        result.classList.add('is-in');
      }
      renderSteps();
    }

    function showResult() {
      Array.prototype.forEach.call(qWrap.querySelectorAll('.v2-finder__q'), function (p) { setOff(p, true); });
      current = questions.length;
      if (!loading) { revealResult(); return; }
      setOff(loading, false);
      loading.classList.remove('is-in');
      void loading.offsetWidth;
      loading.classList.add('is-in');
      renderSteps();
      if (caption) caption.hidden = true;
      if (picks) picks.hidden = true;
      window.clearTimeout(holdTimer);
      holdTimer = window.setTimeout(revealResult, RESULT_HOLD);
    }

    function hideResult() {
      if (!result) return;
      result.classList.remove('is-in');
      result.classList.add('is-out');
      window.setTimeout(function () {
        result.classList.remove('is-out');
        setOff(result, true);
      }, 220);
    }

    function clearSelection(qid) {
      Array.prototype.forEach.call(qWrap.querySelectorAll('.v2-finder__opt.is-on'), function (o) {
        if (!qid || o.getAttribute('data-q') === qid) o.classList.remove('is-on');
      });
    }

    function onOption(btn) {
      var qid = btn.getAttribute('data-q');
      answers[qid] = btn.getAttribute('data-val');
      var opts = btn.parentNode.querySelectorAll('.v2-finder__opt');
      Array.prototype.forEach.call(opts, function (o) { o.classList.toggle('is-on', o === btn); });
      window.setTimeout(function () {
        if (current + 1 < questions.length) showPanel(current + 1, true);
        else showResult();
      }, 320);
    }

    function reset() {
      answers = {};
      clearSelection();
      hideResult();
      showPanel(0);
      window.setTimeout(hideAllCards, 220);
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-q][data-val]');
      if (btn && root.contains(btn)) { onOption(btn); return; }
      if (e.target.closest('[data-finder-back]')) {
        var prev = Math.max(current - 1, 0);
        delete answers[questions[prev].id];
        clearSelection(questions[prev].id);
        showPanel(prev);
        return;
      }
      if (e.target.closest('[data-finder-reset]')) {
        if (typeof opts.onReset === 'function') { opts.onReset(root); return; }
        reset();
        return;
      }
      var card = e.target.closest('[data-handle]');
      if (card && root.contains(card)) {
        var a = e.target.closest('a');
        if (a && !a.classList.contains('v2-finder__card-img')) return;
        e.preventDefault();
        goToProduct(card);
      }
    });

    function firstUnanswered() {
      var i = 0;
      while (i < questions.length && answers[questions[i].id]) i++;
      return i;
    }

    function setAnswer(qid, val) {
      var q = questions.filter(function (x) { return x.id === qid; })[0];
      if (!q || !q.options.some(function (o) { return o.id === val; })) return;
      answers[qid] = val;
      Array.prototype.forEach.call(qWrap.querySelectorAll('[data-q="' + qid + '"]'), function (o) {
        o.classList.toggle('is-on', o.getAttribute('data-val') === val);
      });
      hideResult();
      var next = firstUnanswered();
      if (next >= questions.length) showResult();
      else showPanel(next);
    }

    root.__finderApi = {
      set: setAnswer,
      reset: reset,
      chips: function () { return chipQ ? chipQ.options : []; },
      chipQuestion: function () { return chipQ ? chipQ.id : null; },
      chipTitle: function () { return chipQ ? chipQ.title : ''; },
      chip: function () { return chipQ ? (answers[chipQ.id] || null) : null; },
      answered: function () { return Object.keys(answers).length; }
    };

    buildWizard();
    hideAllCards();

    var preset = opts.answers || {};
    var params = null;
    try { params = new URLSearchParams(window.location.search); } catch (e) {}
    if (params && params.get('finder') === data.category) {
      questions.forEach(function (q) {
        var v = params.get(q.id);
        if (v) preset[q.id] = v;
      });
    }
    if (params && params.get('finder_restore') === data.category) {
      var saved = load('v2finder:answers:' + data.category) || {};
      Object.keys(saved).forEach(function (k) { preset[k] = saved[k]; });
    }
    var first = 0;
    questions.forEach(function (q) {
      var v = preset[q.id];
      if (!v || !q.options.some(function (o) { return o.id === v; })) return;
      answers[q.id] = v;
      var btn = qWrap.querySelector('[data-q="' + q.id + '"][data-val="' + v + '"]');
      if (btn) btn.classList.add('is-on');
    });
    while (first < questions.length && answers[questions[first].id]) first++;
    if (first >= questions.length) showResult();
    else showPanel(first);
  }

  window.v2Finder = {
    init: init,
    initAll: function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-finder]'), function (r) { init(r); });
    }
  };
})();
